import { createSlice } from "@reduxjs/toolkit";
import stringUtils from "../../../../_services/string-utils";

const initialState = {
    submitted: false,
    toggled: false,
    isLoading: false, // TODO: need to change the name
    subloading: false, // TODO: need to change the name

    success: false,
    errorMessage: null,

    modal: false, // TODO: need to change the name
    registering: false,

    isAddUserModalOpen: false,
    addUserToOrganizationModal: false,
    addUserToOrganizationLoading: false,
    addUserToOrganizationErrorMessage: null,
    newUser: {
        registerEmail: "",
        registerFirstName: "",
        registerLastName: "",
        phoneNumber: "",
    },

    removeUserFromOrganizationModal: false,
    removeUserFromOrganizationLoading: false,
    removeUserFromOrganizationErrorMessage: null,
    deleteUser: {},

    isEditingAddress: false,
    isEditingVATRegistrations: false,

    organization: null,
    editOrganization: null,

    hubspotErrorMessage: null,
    hubspotProperties: null,
    hubspotId: null,

    productFruitsUser: null,
    productFruitsChecklists: null,

    dashboardData: null,
    dashboardLoading: false,

    // Per-organization details (incl. scheduledTasks) for the tax-agency dashboard, keyed by orgUUID.
    // Prefetched in the background after the basic dashboard data renders (issue 41294).
    taxAgencyDetails: {},
    taxAgencyDetailsLoading: {},

    updateScheduledTaskLoading: false,
    updateScheduledTaskErrorMessage: false,
    selectedScheduledTask: null,

    restartScheduledTaskLoading: false,
    restartScheduledTaskErrorMessage: null,

    updateLastImportDateLoading: false,
    updateLastImportDateErrorMessage: null,

    migrateToStripeLoading: false,
    migrateToStripeErrorMessage: null,
    stripeCheckoutSession: null,
};

const myOrganizationSlice = createSlice({
    name: "MyOrganization",
    initialState,
    reducers: {
        setOrganizationInfo(state) {
            state.editOrganization = {
                ...state.editOrganization,
                name: state.organization.name,
                contact: state.organization.contact,
                contactMail: state.organization.contactMail,
                invoiceMail: state.organization.invoiceMail,
                phoneNumber: state.organization.phoneNumber,
            };
        },

        toggleUserModal(state, action) {
            const { userToEdit = null } = action.payload || {};

            if (userToEdit) {
                state.newUser = {
                    registerEmail: userToEdit.mail || "",
                    registerFirstName: userToEdit.firstName || "",
                    registerLastName: userToEdit.lastName || "",
                    phoneNumber: userToEdit.phoneNumber || "",
                    platformUserType: userToEdit.platformUserType || "CUSTOMER",
                };
            } else {
                state.newUser = {
                    registerEmail: "",
                    registerFirstName: "",
                    registerLastName: "",
                    phoneNumber: "",
                    platformUserType: "CUSTOMER",
                };
            }

            state.registering = false;
            state.addUserToOrganizationLoading = false;
            state.success = false;
            state.addUserToOrganizationModal = !state.addUserToOrganizationModal;
            state.addUserToOrganizationErrorMessage = null;
        },
        setRegisterField(state, action) {
            state.newUser = action.payload;
        },
        setSubmission(state, action) {
            state.submitted = action.payload;
        },
        setToggle(state) {
            state.toggled = !state.toggled;
        },
        setRemoveUser(state, action) {
            state.deleteUser = action.payload;
        },
        setEditOrganization(state, action) {
            state.editOrganization = action.payload;
        },
        getOrganizationRequest(state) {
            state.isLoading = true;
            state.errorMessage = null;
            state.stripeCheckoutSession = null;
        },
        getOrganizationSuccess(state, action) {
            state.organization = action.payload;
            state.isLoading = false;
        },
        getOrganizationFailure(state, action) {
            state.errorMessage = action.payload;
            state.isLoading = false;
        },
        updateOrganizationRequest(state) {
            state.errorMessage = null;
            state.subloading = true;
        },
        updateOrganizationSuccess(state, action) {
            state.organization = action.payload;
            state.subloading = false;
        },
        updateOrganizationFailure(state, action) {
            state.subloading = false;
            state.errorMessage = action.error;
        },
        clearOrganizationErrorMessage(state) {
            state.errorMessage = null;
        },
        toggleIsEditingAddress(state) {
            state.isEditingAddress = !state.isEditingAddress;
        },
        toggleIsEditingVATRegistrations(state) {
            state.isEditingVATRegistrations = !state.isEditingVATRegistrations;
        },
        toggleAddUserToOrganizationModal(state) {
            state.registering = false;
            state.addUserToOrganizationLoading = false;
            state.success = false;
            state.addUserToOrganizationModal = !state.addUserToOrganizationModal;
            state.addUserToOrganizationErrorMessage = null;
        },
        registerUserToOrganizationRequest(state) {
            state.registering = true;
            state.addUserToOrganizationLoading = true;
            state.addUserToOrganizationErrorMessage = null;
        },
        registerUserToOrganizationSuccess(state) {
            state.registering = false;
            state.success = true;
            state.modal = false;
            state.addUserToOrganizationLoading = false;
            state.addUserToOrganizationErrorMessage = null;
            state.addUserToOrganizationModal = null;
        },
        registerUserToOrganizationFailure(state, action) {
            state.registering = true;
            state.success = false;
            state.addUserToOrganizationLoading = false;
            state.addUserToOrganizationErrorMessage = action.payload;
        },
        removeUserFromOrganizationRequest(state) {
            state.removeUserFromOrganizationLoading = true;
            state.removeUserFromOrganizationErrorMessage = null;
        },
        removeUserFromOrganizationSuccess(state) {
            state.removeUserFromOrganizationLoading = false;
            state.removeUserFromOrganizationModal = false;
        },
        removeUserFromOrganizationFailure(state, action) {
            state.removeUserFromOrganizationLoading = false;
            state.removeUserFromOrganizationErrorMessage = action.payload;
        },
        toggleRemoveUserFromOrganizationModal(state) {
            state.removeUserFromOrganizationLoading = false;
            state.removeUserFromOrganizationErrorMessage = null;
            state.removeUserFromOrganizationModal = !state.removeUserFromOrganizationModal;
        },

        updateAllowedAppsRequest(state) {
            state.errorMessage = null;
            state.subloading = true;
        },
        updateAllowedAppsSuccess(state) {
            state.subloading = false;
        },
        updateAllowedAppsFailure(state, action) {
            state.subloading = false;
            state.errorMessage = action.payload;
        },
        setProductFruitsUser(state, action) {
            if (
                !state.productFruitsUser ||
                !action.payload ||
                !stringUtils.equals(state.productFruitsUser.organizationUUID, action.payload.organizationUUID)
            ) {
                state.productFruitsUser = action.payload;
            }
        },
        setHubspotProperties(state, action) {
            state.hubspotProperties = action.payload;
        },
        setProductFruitsChecklists(state, action) {
            if (
                !state.productFruitsChecklists ||
                !action.payload ||
                !stringUtils.equals(state.productFruitsChecklists.organizationUUID, action.payload.organizationUUID)
            ) {
                state.productFruitsChecklists = action.payload;
            }
        },
        setDashboardDataRequest(state) {
            state.dashboardLoading = true;
            state.dashboardData = null;
            state.taxAgencyDetails = {};
            state.taxAgencyDetailsLoading = {};
        },
        setDashboardData(state, action) {
            state.dashboardData = action.payload;
            state.dashboardLoading = false;
        },
        getTaxAgencyOrgDetailsRequest(state, action) {
            state.taxAgencyDetailsLoading[action.payload] = true;
        },
        getTaxAgencyOrgDetailsSuccess(state, action) {
            state.taxAgencyDetails[action.payload.organizationUUID] = action.payload.details;
            state.taxAgencyDetailsLoading[action.payload.organizationUUID] = false;
        },
        getTaxAgencyOrgDetailsFailure(state, action) {
            state.taxAgencyDetailsLoading[action.payload] = false;
        },

        updateScheduledTaskRequest(state, action) {
            state.updateScheduledTaskLoading = true;
            state.updateScheduledTaskErrorMessage = null;
        },
        updateScheduledTaskSuccess(state, action) {
            state.updateScheduledTaskLoading = false;
        },
        updateScheduledTaskFailure(state, action) {
            state.updateScheduledTaskLoading = false;
            state.updateScheduledTaskErrorMessage = action.payload;
        },
        toggleScheduledTaskModal(state, action) {
            state.selectedScheduledTask = action.payload;
            state.updateScheduledTaskLoading = false;
            state.updateScheduledTaskErrorMessage = null;
        },
        restartScheduledTaskRequest(state) {
            state.restartScheduledTaskLoading = true;
            state.restartScheduledTaskErrorMessage = null;
        },
        restartScheduledTaskSuccess(state) {
            state.restartScheduledTaskLoading = false;
        },
        restartScheduledTaskFailure(state, action) {
            state.restartScheduledTaskLoading = false;
            state.restartScheduledTaskErrorMessage = action.payload;
        },
        updateLastImportDateRequest(state) {
            state.updateLastImportDateLoading = true;
            state.updateLastImportDateErrorMessage = null;
        },
        updateLastImportDateSuccess(state) {
            state.updateLastImportDateLoading = false;
        },
        updateLastImportDateFailure(state, action) {
            state.updateLastImportDateLoading = false;
            state.updateLastImportDateErrorMessage = action.payload;
        },
        migrateToStripeRequest(state, action) {
            state.migrateToStripeLoading = true;
            state.migrateToStripeErrorMessage = null;
        },
        migrateToStripeSuccess(state, action) {
            state.migrateToStripeLoading = false;
            state.stripeCheckoutSession = action.payload;
            state.submitted = false;
        },
        migrateToStripeFailure(state, action) {
            state.migrateToStripeLoading = false;
            state.migrateToStripeErrorMessage = action.payload;
        },
    },
});

export default myOrganizationSlice;
